import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Plus, PencilSimple, Trash } from "@phosphor-icons/react";
import api from "@/lib/api";

const upsell = (msg) => toast.error(msg, { action: { label: "See plans", onClick: () => { window.location.href = "/pricing"; } } });

// Pick between my named meal plans and plans shared with me; create / rename / delete my own.
export const PlannerSwitcher = ({ planners, value, onChange, onChanged, role }) => {
  const owned = planners.owned || [];
  const shared = planners.shared || [];
  const current = owned.find((p) => p.plan_id === value) || (!value && owned.find((p) => p.is_default));

  const create = async () => {
    if (!planners.paid && owned.length >= 1) { upsell("Several named meal plans are part of every paid plan. Free plans include one."); return; }
    const name = window.prompt("Name your new meal plan (e.g. Weeknights, Christmas)");
    if (!name?.trim()) return;
    try {
      const { data } = await api.post("/meal-planners", { name });
      await onChanged();
      onChange(data.plan_id);
      toast.success(`Created “${data.name}”`);
    } catch (e) {
      (e?.response?.status === 402 ? upsell : toast.error)(e?.response?.data?.detail || "Couldn't create the meal plan");
    }
  };
  const rename = async () => {
    const name = window.prompt("Rename this meal plan", current?.name || "");
    if (!name?.trim() || !current) return;
    try { await api.patch(`/meal-planners/${current.plan_id}`, { name }); await onChanged(); }
    catch (e) { toast.error(e?.response?.data?.detail || "Couldn't rename"); }
  };
  const remove = async () => {
    if (!current || current.is_default || !window.confirm(`Delete “${current.name}” and every week in it? People you shared it with lose access.`)) return;
    try { await api.delete(`/meal-planners/${current.plan_id}`); toast.success("Meal plan deleted"); onChange(""); onChanged(); }
    catch (e) { toast.error(e?.response?.data?.detail || "Couldn't delete"); }
  };

  return (
    <span className="inline-flex items-center gap-1.5 flex-wrap" data-testid="planner-switcher-wrap">
      <select value={value} onChange={(e) => onChange(e.target.value)} aria-label="Choose which meal plan to view"
              data-testid="planner-switcher" className="input-rf !py-1.5 !w-auto text-sm font-bold">
        {owned.map((p) => <option key={p.plan_id} value={p.is_default ? "" : p.plan_id}>{p.name}</option>)}
        {shared.length > 0 && (
          <optgroup label="Shared with me">
            {shared.map((p) => <option key={p.share_id} value={p.resource_id}>{p.owner_name}&apos;s {p.name}{p.role === "view" ? " (view)" : ""}</option>)}
          </optgroup>
        )}
      </select>
      <button type="button" onClick={create} data-testid="planner-new" title="New meal plan" className="p-2 rounded-full hover:bg-rf-cream-alt"><Plus size={16} weight="bold" /></button>
      {role === "owner" && current && (
        <>
          <button type="button" onClick={rename} data-testid="planner-rename" title="Rename meal plan" className="p-2 rounded-full hover:bg-rf-cream-alt"><PencilSimple size={16} /></button>
          {!current.is_default && <button type="button" onClick={remove} data-testid="planner-delete" title="Delete meal plan" className="p-2 rounded-full hover:bg-red-50 text-red-700"><Trash size={16} /></button>}
        </>
      )}
      {!planners.paid && owned.length >= 1 && role === "owner" && (
        <Link to="/pricing" className="text-xs font-bold text-rf-orange hover:underline" data-testid="planner-upgrade-hint">More plans with a paid plan</Link>
      )}
    </span>
  );
};
